<template>
  <v-container fill-height class="justify-center">
    <div class="background-container"></div>
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on }">
        <v-row align="center" justify="center">
          <v-col sm="7" lg="5" xl="3">
            <v-card outlined>
              <v-img
                src="/img/icons/logo.png"
                alt="logo"
                aspect-ratio="1"
                height="200"
                contain
              />
              <v-card-title class="justify-center headline">
                התחברות למערכת
              </v-card-title>
              <v-form ref="form">
                <v-card-text>
                  <v-text-field
                    @keyup.enter="login"
                    name="email"
                    label="אימייל"
                    v-model="loginData.email"
                    outlined
                    prepend-inner-icon="mdi-account"
                    :rules="[rules.required, rules.isEmailValid]"
                  ></v-text-field>
                  <v-text-field
                    @keyup.enter="login"
                    name="password"
                    type="password"
                    label="סיסמא"
                    v-model="loginData.password"
                    outlined
                    prepend-inner-icon="mdi-lock"
                    :rules="[rules.required, rules.min]"
                  ></v-text-field>
                  <div class="mb-4">
                    <v-btn
                      color="secondary"
                      block
                      large
                      :disabled="!isLoginFormValid"
                      @click="login()"
                      >התחבר</v-btn
                    >
                  </div>
                  <div class="red--text caption">
                    <p v-if="hasAuthenticateionFailed">
                      אימייל או סיסמא לא נכונים
                    </p>
                  </div>
                  <div class="body-2 text-center">
                    <a v-on="on" class="accent--text">שכחתי סיסמא</a>
                  </div>
                </v-card-text>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </template>
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-text-field
            name="email"
            label="אימייל"
            v-model="loginData.email"
            outlined
            prepend-inner-icon="mdi-account"
            :rules="[rules.required, rules.isEmailValid]"
            @keyup.enter="forgotPassword"
          ></v-text-field>
          <div class="mb-4">
            <v-btn
              v-bind:id="'forgotPasswordButton'"
              large
              :disabled="!isForgotPasswordFormValid"
              @click="forgotPassword()"
              >שלח</v-btn
            >
          </div>
          <div class="caption">
            <p class="red--text" v-if="hasForgotPasswordFailed">
              אימייל לא קיים במערכת
            </p>
            <p class="green--text" v-if="showSuccessMessage">
              סיסמתך אופסה, גש לתיבת הדואר
            </p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { Action } from 'vuex-class'
import { checkIfEmailIsValid } from '../utils/helpers'

@Component()
export default class Login extends Vue {
  dialog = false;
  hasAuthenticateionFailed = false;
  hasForgotPasswordFailed = false;
  showSuccessMessage = false;

  loginData = {
    email: '',
    password: ''
  };

  rules = {
    required: (value) => !!value || 'שדה חובה',
    min: (value) => value.length >= 8 || 'לפחות 8 תווים',
    isEmailValid: (value) => checkIfEmailIsValid(value) || 'אימייל לא תקין'
  };

  @Action sendForgotPassword;
  @Action signIn;

  get isLoginFormValid () {
    return (
      this.loginData.password.length >= 8 &&
      checkIfEmailIsValid(this.loginData.email)
    )
  }

  get isForgotPasswordFormValid () {
    return checkIfEmailIsValid(this.loginData.email)
  }

  async login () {
    if (this.isLoginFormValid) {
      const isSuccessful = await this.signIn(this.loginData)
      this.hasAuthenticateionFailed = !isSuccessful
      if (!this.hasAuthenticateionFailed) {
        this.$router.push('/users')
      }
    }
  }

  async forgotPassword () {
    if (this.isForgotPasswordFormValid) {
      this.showSuccessMessage = await this.sendForgotPassword(
        this.loginData.email
      )
      this.hasForgotPasswordFailed = !this.showSuccessMessage
    }
  }
}
</script>
